export default __webpack_public_path__ + "static/media/IMG_4592.c0f70f57.jpg";